import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import { BACKEND_URL } from "../../../config";

function Dashboard() {
  const [dashboardData, setDashboardData] = useState({
    stats: {
      total_orders: 0,
      total_revenue: 0,
      total_users: 0,
      total_products: 0,
      total_categories: 0,
    },
  });

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api.php?module=dashboard`);
      const result = await response.json();

      if (result.success) {
        setDashboardData(result.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const dashboardCards = [
    {
      title: "Total Sales",
      value: new Intl.NumberFormat("en-EU", {
        style: "currency",
        currency: "EUR",
      }).format(dashboardData.stats.total_revenue || 0),
      colorClass: "card-sales",
      icon: "💶",
    },
    {
      title: "Orders",
      value: dashboardData.stats.total_orders || 0,
      colorClass: "card-orders",
      icon: "🛒",
    },
    {
      title: "Users",
      value: dashboardData.stats.total_users || 0,
      colorClass: "card-users",
      icon: "👥",
    },
    {
      title: "Products",
      value: dashboardData.stats.total_products || 0,
      colorClass: "card-products",
      icon: "📦",
    },
    {
      title: "Categories",
      value: dashboardData.stats.total_categories || 0,
      colorClass: "card-category",
      icon: "📂",
    },
  ];

  return (
    <div className="admin-page">

      <h2>Dashboard</h2>

      <div className="dashboard-cards">
        {dashboardCards.map((card, i) => (
          <div key={i} className="card">
            <div className={`card-icon ${card.colorClass}`}>
              {card.icon}
            </div>

            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.value}</p>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default Dashboard;